import { HOME_PATH } from "configs/paths";
import React from "react";
import { Navbar, NavbarBrand, Breadcrumb, BreadcrumbItem } from "reactstrap";
import NavLogo from "assets/img/logo-mobile.png";
import "./index.css";

function NavBreadcrumb({ resultName }) {
  return (
    <Breadcrumb>
      <BreadcrumbItem>
        <a href={HOME_PATH}>ค้นหาบุคลากร</a>
      </BreadcrumbItem>
      {
        resultName && (
          <BreadcrumbItem active>{resultName}</BreadcrumbItem>
        )
      }
    </Breadcrumb>
  );
}

export default function SubTemplate({ displayName, children }) {

  return (
    <>
      <Navbar className="navbar-main" expand="md">
        <NavbarBrand href="http://www.eng.psu.ac.th">
          <img className="nav-logo" src={NavLogo} alt="nav-logo" />
        </NavbarBrand>
      </Navbar>
      <NavBreadcrumb resultName={displayName} />
      <div className="content-container">{children}</div>
    </>
  );
}
